import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Error } from '@material-ui/icons';
import Grid from '@material-ui/core/Grid';

const useStyles = makeStyles((theme) => ({
    root: {
      '& > .fa': {
        margin: theme.spacing(2),
      },
    },
  }));


const Errores = ({ leyenda }) => {
    const classes = useStyles();
    return (
        <div>
            <div className={classes.root}>
           
                <Grid container direction="column" justifyContent="center" alignItems="center"    >               
                        <Error  color="secondary" fontSize="large" />
                        <p>{leyenda}</p>
                </Grid>
            </div>
        </div>
    );
};

export default Errores;